import { Message, Form } from 'semantic-ui-react'

import DeliveryPicker from 'lib/components/DeliveryPicker'
import useUpdateUserData from 'lib/hooks/useUpdateUserData'
import { useAuth } from 'lib/context/AuthContext'
import PhoneVerification from 'lib/components/PhoneVerification'

const DeliveryPreference = () => {
  const updateUserData = useUpdateUserData()
  const [user] = useAuth()

  return (
    <>
      <Message
        attached="top"
        header="Delivery Preferences"
        content="Settings for receiving alerts"
        size="tiny"
      />
      <Form className="attached fluid segment" size="large">
        <DeliveryPicker
          value={user.data.delivery}
          onChange={delivery => updateUserData({ delivery })}
        />

        <Form.Field
          control="input"
          value={user.auth?.email}
          readOnly
          label="Email Address"
          id="emailAddress"
        />

        <PhoneVerification user={user} />
      </Form>
    </>
  )
}

export default DeliveryPreference
